import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useSelector } from 'react-redux';

import { scrollTo } from 'dpl/shared/utils';
import NullEB from 'dpl/components/NullEB';
import NotificationCount from 'dpl/common/components/NotificationCount';
import BreederProfileNearbyCities from 'dpl/components/BreederProfile/Index/BreederProfileList/BreederProfileNearbyCities';
import RelatedBreedsModule from 'dpl/puppy_search_results/components/v2/RelatedBreedsModule';

export const HEADER_HEIGHT = 74;

export default function BreederProfileLayout({ sectionTitlesAndComponents }) {
  const { breeds, breederProfileId, citySlug, locationTitle } = useSelector(
    ({ server }) => server
  );

  const sectionElsByTitle = {};

  return (
    <div className="BreederProfileLayout container">
      <div className="row no-gutters bb b--lightest-gray mb6 mb20-lg">
        <div className="col-3 d-none d-xl-block">
          <div className="h-100 br b--lightest-gray mr10">
            <ul className="BreederProfileShowPage__leftNav sticky left-0 pv12">
              {sectionTitlesAndComponents.map(
                ({ title, count }) =>
                  title && (
                    <li key={title} className="mb4">
                      <button
                        type="button"
                        className="flex transition hover-black black-50"
                        onClick={() => {
                          scrollTo({
                            top:
                              sectionElsByTitle[title].getBoundingClientRect()
                                .top -
                              HEADER_HEIGHT +
                              window.pageYOffset +
                              1,
                            behavior: 'smooth'
                          });
                        }}
                      >
                        <span>{title}</span>
                        {typeof count === 'number' && (
                          <span className="pl2">
                            <NotificationCount
                              count={count}
                              unreadColor="purple"
                            />
                          </span>
                        )}
                      </button>
                    </li>
                  )
              )}
            </ul>
          </div>
        </div>
        <div className="col-xl-9">
          {sectionTitlesAndComponents.map(({ Component, key, title }, idx) => (
            <NullEB key={key}>
              <div
                className={classnames('pv6 pv12-lg b--lightest-gray', {
                  'bb b--lightest-gray':
                    sectionTitlesAndComponents.length - 1 !== idx
                })}
                ref={el => {
                  title && el && (sectionElsByTitle[title] = el);
                }}
              >
                <Component />
              </div>
            </NullEB>
          ))}
        </div>
      </div>

      <div className="BreederRelatedLinks">
        <RelatedBreedsModule className="mb6 mb20-lg" />
        {Boolean(citySlug || locationTitle) &&
          breeds.map(b => (
            <BreederProfileNearbyCities
              key={b.id}
              breedId={b.id}
              breederProfileId={breederProfileId}
              breedName={b.name}
              wideLayout
              limit={10}
            />
          ))}
      </div>
    </div>
  );
}

BreederProfileLayout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  sectionTitlesAndComponents: PropTypes.array
};

BreederProfileLayout.defaultProps = {
  sectionTitlesAndComponents: []
};
